import React from 'react';

const Breathing: React.FC = () => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white shadow rounded-lg p-6 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Breathing Exercises</h1>
        <p className="text-gray-600 mb-6">
          Practice mindful breathing to reduce stress and improve focus.
        </p>
        <div className="space-y-4">
          <div className="w-32 h-32 mx-auto bg-blue-100 rounded-full flex items-center justify-center">
            <div className="w-24 h-24 bg-blue-200 rounded-full animate-pulse"></div>
          </div>
          <p className="text-lg text-gray-700">Breathe in... breathe out...</p>
        </div>
      </div>
    </div>
  );
};

export default Breathing;
